import React from 'react';

import cx from 'classnames';
import { Link, NavLink } from 'react-router-dom';

import Typography from 'components/typography';

import { REAL_TIME_OVERVIEW_ROUTE, RISK_SCORE_ROUTE } from 'constants/routes';

import { ReactComponent as Donut } from 'assets/icons/donut-icon.svg';
import { ReactComponent as LogoV2 } from 'assets/icons/logo-v2-icon.svg';
import { ReactComponent as Shield } from 'assets/icons/shield-icon.svg';

import s from './LinksGroup.module.scss';

const LinksGroup = () => {
  return (
    <div className={s.leftGroup}>
      <div className={s.logoWithActionButton}>
        <Link to={REAL_TIME_OVERVIEW_ROUTE}>
          <LogoV2 className={s.logo} />
        </Link>
      </div>
      <div className={s.leftLinkGroup}>
        <NavLink
          to={REAL_TIME_OVERVIEW_ROUTE}
          className={({ isActive }) => cx(isActive ? s.activeLink : s.nonActiveLink)}>
          <Donut />
          <Typography size="15" weight="600">
            Overview
          </Typography>
        </NavLink>
        <NavLink
          to={RISK_SCORE_ROUTE}
          className={({ isActive }) => cx(isActive ? s.activeLink : s.nonActiveLink)}>
          <Shield />
          <Typography size="15" weight="600">
            Risk Score
          </Typography>
        </NavLink>
      </div>
    </div>
  );
};

export default LinksGroup;
